import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from '@core/services/env.service';
import { PreflashMonitoringApiResponse, PreflashMonitoringDetailResponse } from '@shared/models/PreflashMonitoring';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreflashMonitoringService {
  private readonly url: string;

  constructor(private readonly httpClient: HttpClient, envService: EnvService) {
    this.url = `${envService.apiUrl}fcsc-calculation-status`;
  }

  getCalculationStatus(page = 1, pageSize = 100): Observable<PreflashMonitoringApiResponse> {
    const params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);

    return this.httpClient.get<PreflashMonitoringApiResponse>(this.url, { params });
  }

  getCalculationDetails(vin: string): Observable<PreflashMonitoringDetailResponse> {
    return this.httpClient.get<PreflashMonitoringDetailResponse>(`${this.url}/${encodeURIComponent(vin)}`, {
      headers: { 'X-PREFLASH-UI': 'TRUE' },
    });
  }
}